// extracted by mini-css-extract-plugin
module.exports = {"root":"LayoutSettings_root__7gIGR","content":"LayoutSettings_content__3Zi07"};